import { Routes } from '@angular/router';
import { GalleryPageContainerComponent } from './gallery-page-container/gallery-page-container.component';
import { LifeAtKalpitaComponent } from './life-at-kalpita/life-at-kalpita.component';
import { LearnWithKalpitaComponent } from './learn-with-kalpita/learn-with-kalpita.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';

export const GalleryPage_Routes: Routes = [
    {path: '', component: GalleryPageContainerComponent,children: [
        {path: 'life-at-kalpita', component: LifeAtKalpitaComponent},
        {path: 'learn-with-kalpita', component: LearnWithKalpitaComponent},
        {path: 'kalpita-testimonials', component: TestimonialsComponent}
    ]}
]